import { EnvelopeIcon, PhoneIcon, SmileySadIcon } from "@phosphor-icons/react";
import {
  contactEmail,
  contactPhoneNumber,
  weekendHotlineHours,
  workingDaysHotlineHours,
} from "apps/visits/core/config";
import { useTranslation } from "react-i18next";
import { IntersectionFadeIn } from "@/core/shared/v2/ui/intersection-fade-in";
import { Card, Layout } from "../components";

export const PhoneVerificationError = () => {
  const { t } = useTranslation();
  return (
    <IntersectionFadeIn>
      <Layout>
        <Card className="mt-10 flex flex-col items-center">
          <SmileySadIcon className="mb-2 size-8" />
          <h1 className="text-center font-semibold text-2xl md:text-left">
            {t("GROUP_ACTIONS_ORDERING.PHONE_VERIFICATION_ERROR.TITLE")}
          </h1>
          <p className="mt-4 text-center md:text-left">
            {t("GROUP_ACTIONS_ORDERING.PHONE_VERIFICATION_ERROR.DESCRIPTION")}
          </p>
          <div className="mt-6 flex flex-col gap-6 md:flex-row md:gap-8">
            <div className="flex items-center gap-3">
              <span className="flex items-center justify-center rounded-full bg-secondary p-3 text-primary">
                <EnvelopeIcon className="size-6" />
              </span>
              <a href={`mailto:${contactEmail}`} className="font-semibold text-primary">
                {contactEmail}
              </a>
            </div>
            <div className="flex items-center gap-3">
              <span className="flex items-center justify-center rounded-full bg-secondary p-3 text-primary">
                <PhoneIcon weight="fill" className="size-6" />
              </span>
              <a href={`tel:${contactPhoneNumber}`} className="font-semibold text-primary">
                {contactPhoneNumber}
              </a>
            </div>
          </div>
          <p className="mt-8 text-center text-xs text-zinc-500 md:text-left">
            {t("GROUP_ACTIONS_ORDERING.PHONE_VERIFICATION_ERROR.HOTLINE_HOURS", {
              workingDaysHotlineHours,
              weekendHotlineHours,
            })}
          </p>
        </Card>
      </Layout>
    </IntersectionFadeIn>
  );
};
